"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var bannerZoneServices_service_1 = require("src/app/Services/bannerZoneServices.service");
var service_service_1 = require("src/app/Services/service.service");
var BannerZoneMapComponent = /** @class */ (function () {
    function BannerZoneMapComponent(bannersService, service) {
        this.bannersService = bannersService;
        this.service = service;
        this.targetIsHorizontal = false;
        this._zoneType = "";
        this.userBaners = [];
        this.userBanerIndex = null;
        this.rndUserBanerImg = null;
        this.rndUserBanerUrl = null;
        this.banerChance = 0; //1 = 100%, 0.5 = 50%
        this.isMobile = false;
        this.getValidUrl = function (url) {
            if (url === void 0) { url = ""; }
            if (url === "#")
                return url;
            var newUrl = window.decodeURIComponent(url);
            newUrl = newUrl.trim().replace(/\s/g, "");
            if (/^(:\/\/)/.test(newUrl)) {
                return "http" + newUrl;
            }
            if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
                return "http://" + newUrl;
            }
            return newUrl;
        };
        this.zoneParams = new BannerParams();
    }
    Object.defineProperty(BannerZoneMapComponent.prototype, "zoneType", {
        get: function () {
            if (Array.isArray(this._zoneType)) {
                this._zoneType = this._zoneType[Math.floor(Math.random() * this._zoneType.length)];
            }
            return this._zoneType;
        },
        set: function (value) {
            this._zoneType = value;
        },
        enumerable: true,
        configurable: true
    });
    BannerZoneMapComponent.prototype.mapParams = function (zone) {
        // switch(zone)
        // {
        //   case "Main-Home-Standard-Top":
        //     this.zoneParams.height = 728;
        //     this.zoneParams.width = 90;
        //     this.zoneParams.url = '//a.realsrv.com/iframe.php?idzone=3944080&size=728x90"';
        //   return;
        // }
    };
    BannerZoneMapComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (Math.random() < this.banerChance) {
            this.sub = this.bannersService.userBanersIsReady$.subscribe(function (result) {
                _this.userBaners = _this.bannersService.userBaners;
                if (_this.userBaners.length > 0) {
                    var randomBaner = Math.floor(Math.random() * _this.userBaners.length);
                    _this.userBanerIndex = randomBaner;
                    _this.rndUserBanerUrl = _this.userBaners[_this.userBanerIndex].banerUrl;
                    var banerPath = "";
                    if (_this.isMobile)
                        banerPath = _this.userBaners[_this.userBanerIndex].mobileImage;
                    else if (_this.targetIsHorizontal) {
                        banerPath = _this.userBaners[_this.userBanerIndex].desktopImageHorizontal;
                    }
                    else {
                        banerPath = _this.userBaners[_this.userBanerIndex].desktopImageVertical;
                    }
                    _this.bannersService.removeUsedBanerFromList(_this.userBanerIndex);
                    _this.rndUserBanerImg = banerPath;
                }
            });
        }
    };
    BannerZoneMapComponent.prototype.ngOnDestroy = function () {
        if (this.sub) {
            this.sub.unsubscribe();
        }
        if (this.userBanerIndex) {
            this.bannersService.addUserBaner(this.userBaners[this.userBanerIndex]);
        }
    };
    return BannerZoneMapComponent;
}());
exports.BannerZoneMapComponent = BannerZoneMapComponent;
var BannerParams = /** @class */ (function () {
    function BannerParams() {
    }
    return BannerParams;
}());
exports.BannerParams = BannerParams;
